import { Component } from "react";
import Loader from "../../../../../utils/Loader";
import { ToastContainer } from "react-toastify";
import ExhibitorTopMenu from "../../../../../common_components/exhibitor_module_topmenu";
import ManualFormTitleStrip from "../../../../../common_components/ManualFormTitleStrip";
import { withRouter } from "../../../../../utils/withRouter";
import { connect } from "react-redux";
import {
  addExhibitorBadge_action,
  getExhibitorBadgeDetails_action,
  updateExhibitorBadge_action,
  deleteExBadgeDoc_action,
  defaultExhBadgeDetails_action,
  getExhBadgeStatusCount_action
} from "../../../../../actions/exhibitor_module_actions/manual_Forms_actions/forms_actions/exhibitor_badge_action/exhibitor_badge_action";
import { fill_action } from "../../../../../actions/fillCombo_action";
import {
  countryActionId,
  toastError,
  toastSuccess,
  exhibitorBadgeVisitDaysActionId,
  cityActionId,
  stateActionId,
  ProductCategoryActionId,
  mainChapterListActionId,
  formatAmount,
} from "../../../../../utils/constants";
import ExhibitorDrawer from "../../../../../common_components/exhibitor_module_drawer";
import ExhibitorHeader from "../../../../../common_components/exhibitor_module_header";
import { data } from "jquery";
import Resizer from "react-image-file-resizer";
import { all } from "axios";
import Modal from "react-modal";
import HeaderWithLogo from "../../../../../common_components/header_with_logo";
import AdminDrawer from "../../../../../common_components/admin_module_drawer";
import moment from "moment";
import {
  emailValidator,
  mobileNoValidator,
} from "../../../../../utils/Validator";
import Select from "react-select";
import { ThirtyFpsSelect } from "@mui/icons-material";
import VendorDrawer from "../../../../../common_components/vendor_module_drawer";
import ConfirmationModal from "../../../../../common_components/confirmationa_modal";

const customStyles = {
  control: (provided) => ({
    ...provided,
    borderColor: "#c9c9c9", // Blue border color
    boxShadow: "none",
    "&:hover": {
      borderColor: "#80bdff", // Blue border color on hover
    },
  }),
  multiValue: (provided) => ({
    ...provided,
    borderRadius: "14px",
    padding: "4px",
    backgroundColor: "#00BCD4", // Blue background color for selected value
  }),
  multiValueLabel: (provided) => ({
    ...provided,
    color: "white", // Text color for selected value
    fontSize: "12px",
  }),
  multiValueRemove: (provided) => ({
    ...provided,
    color: "white",
    "&:hover": {
      backgroundColor: "#00BCD4",
      color: "#fff", // Blue border color on hover
    }, // Remove icon color for selected value
  }),
};
class AddExhibitorBadge extends Component {
  // initialize constructor
  constructor(props) {
    super(props);
    this.state = {
      isLoading: false,
      isDisplayCountryList: false,
      confirmationObj: { message: '', buttonName: '', action: '' },
      popArg: [],
      isOpenConfirmationModal: false,
      isAdd: false,
      isUpdate: false,
      exBadgeFormId: "",
      badgeLength: "",
      vaccFileName: "",
      isDelOpen: false,
      isView: false,
      filePath: "",

      // fields
      exhibitorName: "",
      designation: "",
      country: "",
      countryId: "",
      category: "",
      companyName: "",
      email: "",
      mobileNo: "",
      remarks: "",
      daysList: [],
      allDaysList: [],
      vaccineCertificateFile: "",
      vaccineCertificateFileType: "",

      // List
      countryList: [],
      tempCountryList: [],

      // err messages
      exhibitorNameErr: "",
      designationErr: "",
      countryErr: "",
      categoryErr: "",
      companyNameErr: "",
      mobileNoErr: "",
      emailErr: "",
      UnPaid: false,
      DeadlineDate: "",
      StatusID: "",
      cityName: "",
      stateName: "",
      ExhBadgesProductCategoryList: [],
      stateList: [],
      tempStateList: [],
      cityList: [],
      tempCityList: [],
      isDisplayCityList: false,
      cityNameErr: "",
      stateNameErr: "",
      ProductCategoryList: [],
      primaryChapterList: [],
      isShowVaccination: false,
      PriceList: [],
      CurrencyName: "",
      CGST: "",
      IGST: "",
      SGST: "",
      Is_View: false,
      AllDayPrice: "",
      SingleDayPrice: "",
      exhbitorBadgeList: [],
      selectedBadges: [],

      RoleID: sessionStorage.getItem("RoleIDSS"),
      Is_View:
        this.props.location.state != null && this.props.location.state.is_View != null
          ? this.props.location.state.is_View
          : sessionStorage.getItem("RoleIDSS") != 1 && sessionStorage.getItem("RoleIDSS") != 8,
      isHideSection: sessionStorage.getItem("RoleIDSS") != 1 && sessionStorage.getItem("RoleIDSS") != 8,
      MaxUnpaidBadge: 0,
      storedExhRegistrationID: null,
      storedExhBadgesFormID: null,
      MaxUnpaidBadgeAllow: 0,
      IsIGST: false,
      exhBadgeStatusCountList: [],
      IsMixExhibitor: false,
      companyList: [],
    };
    this.OnCancel = this.OnCancel.bind(this);
    this.inputValidate = this.inputValidate.bind(this);
    this.getFillList = this.getFillList.bind(this);
    this.onCountrySearch = this.onCountrySearch.bind(this);
    this.renderCountryList = this.renderCountryList.bind(this);
    this.onSubmitExhibitorBadge = this.onSubmitExhibitorBadge.bind(this);
    this.onFilePick = this.onFilePick.bind(this);
    this.onPdfSelect = this.onPdfSelect.bind(this);
    this.resizeFile = this.resizeFile.bind(this);
    this.onSelectDates = this.onSelectDates.bind(this);
    this.onSelectAllDates = this.onSelectAllDates.bind(this);
    this.getExhibitorBadgeDetails = this.getExhibitorBadgeDetails.bind(this);
    this.onUpdateExhibitorBadge = this.onUpdateExhibitorBadge.bind(this);
    this.onCrossClick = this.onCrossClick.bind(this);
    this.onDocDelete = this.onDocDelete.bind(this);
    this.handleDelete = this.handleDelete.bind(this);
    this.mobileValidation = this.mobileValidation.bind(this);
    this.emailValidation = this.emailValidation.bind(this);
    this.handleConfirmation = this.handleConfirmation.bind(this)
  }


  handleConfirmation(flag) {
    const { confirmationObj, popArg } = this.state;
    if (flag) {
      if (confirmationObj.action == 0) {
        this.onSubmitExhibitorBadge()
      }
      if (confirmationObj.action == 1) {
        this.onUpdateExhibitorBadge()
      }
    }
    this.setState({ isOpenConfirmationModal: false })
  }

  async componentDidMount() {
    console.log("pppppppppppp", this.props);
    await this.getExhBadgeStatusCount();
    await this.defaultExhBadgeDetails();
    await this.getFillList(
      countryActionId,
      sessionStorage.getItem("sessionExhibitionID"),
      "",
      "",
      "",
      ""
    );
    await this.getFillList(
      exhibitorBadgeVisitDaysActionId,
      sessionStorage.getItem("sessionExhibitionID"),
      "",
      "",
      "",
      ""
    );
    await this.getFillList(
      cityActionId,
      sessionStorage.getItem("sessionExhibitionID"),
      "",
      "",
      "",
      ""
    );
    await this.getFillList(
      stateActionId,
      sessionStorage.getItem("sessionExhibitionID"),
      "",
      "",
      "",
      ""
    );
    await this.getFillList(
      ProductCategoryActionId,
      sessionStorage.getItem("sessionExhibitionID"),
      "",
      "",
      "",
      ""
    );
    setTimeout(() => {
      this.getFillList(
        mainChapterListActionId,
        sessionStorage.getItem("sessionExhibitionID"),
        "",
        "",
        "",
        ""
      );
    }, 200);
    this.setState({
      isAdd:
        this.props.location.state != null && this.props.location.state.is_add
          ? this.props.location.state.is_add
          : false,
      isUpdate:
        this.props.location.state != null && this.props.location.state.is_update
          ? this.props.location.state.is_update
          : false,
      isView:
        this.props.location.state != "" && this.props.location.state.is_View
          ? this.props.location.state.is_View
          : false,
      exBadgeFormId:
        this.props.location.state != null &&
          this.props.location.state.exhibitorBadgeFormId
          ? this.props.location.state.exhibitorBadgeFormId
          : "",
      badgeLength:
        this.props.location.state != null &&
          this.props.location.state.exBadgeListLength
          ? this.props.location.state.exBadgeListLength
          : "",
      UnPaid:
        this.props.location.state != null && this.props.location.state.UnPaid
          ? this.props.location.state.UnPaid
          : false,
      StatusID:
        this.props.location.state != null && this.props.location.state.StatusID
          ? this.props.location.state.StatusID
          : null,
      MaxUnpaidBadge:
        this.props.location.state != null && this.props.location.state.MaxUnpaidBadge
          ? this.props.location.state.MaxUnpaidBadge
          : false,
      MaxUnpaidBadgeAllow:
        this.props.location.state != null && this.props.location.state.MaxUnpaidBadgeAllow
          ? this.props.location.state.MaxUnpaidBadgeAllow
          : false,
      DeadlineDate:
        this.props.location.state != null &&
          this.props.location.state != "" &&
          this.props.location.state.Deadline != ""
          ? moment(this.props.location.state.Deadline).format("DD-MM-YYYY")
          : "",
    });
    // Calling Get Exhibitor Badges Details on Update
    (await this.props.location.state) != null &&
      this.props.location.state.is_add &&
      this.setState({
        // companyName: JSON.parse(sessionStorage.getItem("sessionHeaderData"))[0][
        //   "CompanyName"
        // ],
      });
    if ((await this.props.location.state) != null &&
      (this.props.location.state.is_update ||
        this.props.location.state.is_View)) {
      await this.getExhibitorBadgeDetails();
    }
    console.log("addd", this.props);
  }

  async defaultExhBadgeDetails() {
    this.setState({ isLoading: true });
    this.props
      .defaultExhBadgeDetails_action()
      .then((data) => {
        if (data.error != 1) {
          if (data.data.length > 0) {
            data.data.map((item, i) => {
              if (i == 0) {
                item["Quantity"] = 1;
                item["Amount"] = item.Rates;
              }
            });
            console.log("data.data[1][0].IsMixExhibitor", data.data[1][0].IsMixExhibitor)
            this.setState({
              companyName: data.data[1][0].IsMixExhibitor ? "" : data.data[1][0].ExhibitorName,
              IsMixExhibitor: data.data[1][0].IsMixExhibitor || false,
              companyList: data.data[2] || [],
              PriceList: data.data,
              CGST: data.data[0][0]["CGST"] * 100,
              SGST: data.data[0][0]["SGST"] * 100,
              IGST: data.data[0][0]["IGST"] * 100,
              CurrencyName: data.data[0][0]["CurrencyName"],
              AllDayPrice: data.data[0][0]["Rates"],
              SingleDayPrice: data.data[0][1]["Rates"],
            });
          }
        } else {
          toastError(data.msg);
        }
        this.setState({ isLoading: false });
      })
      .catch((err) => {
        console.log(err);
      });
  }

  getExhBadgeStatusCount() {
    this.props
      .getExhBadgeStatusCount_action()
      .then((data) => {
        if (data.error != 1) {
          this.setState({ exhBadgeStatusCountList: data.data })
        } else {
          toastError(data.msg);
        }
      })
      .catch((err) => {
        console.log(err);
      });
  }

  getExhibitorBadgeDetails() {
    this.setState({ isLoading: true });
    var exhibitorBadgeFormId = this.props.location.state.exhibitorBadgeFormId;

    this.props
      .getExhibitorBadgeDetails_action(exhibitorBadgeFormId)
      .then((data) => {
        if (data.error != 1) {
          const badgeDetails = data.data[0][0];
          const additionalData = data.data[1] && data.data[1].length > 0 ? data.data[1][0] : null;

          // Store additional data immediately
          if (additionalData) {
            this.setState({
              storedExhRegistrationID: additionalData.ExhRegistrationID || null,
              storedExhBadgesFormID: additionalData.ExhBadgesFormID || null
            });
            console.log("Stored Additional Data: ", additionalData);
          }

          setTimeout(() => {
            const { allDaysList, daysList, vaccFileName } = this.state;
            console.log("daysList : ", daysList);
            var visitDays =
              badgeDetails["VisitDays"] != null
                ? badgeDetails["VisitDays"]
                  .split(",")
                  .map((data) => data.trim())
                : [];
            var filePath = badgeDetails["VaccinationCertifcateFilePath"];
            var array =
              badgeDetails["VaccinationCertifcateFilePath"] != null &&
              badgeDetails["VaccinationCertifcateFilePath"] != "" &&
              filePath.split("/");
            const FileName = array[array.length - 1];
            this.setState({ vaccFileName: FileName });

            daysList.length > 0 &&
              daysList.map((element) => {
                for (let i = 0; i < visitDays.length; i++) {
                  if (visitDays[i] == element.description) {
                    element.isSelect = true;
                  } else {
                    if (visitDays[i] == "All Days") {
                      allDaysList.length > 0 &&
                        allDaysList.map((item) => {
                          item.isSelect = true;
                        });
                      element.isReadOnly = true;
                    }
                  }
                }
              });
            const list = daysList.filter((item) => item.isSelect);
            if (list.length > 0) {
              this.enterQuantity(0, 0, false);
              this.enterQuantity(list.length, 1, true);
            } else {
              this.enterQuantity(1, 0, true);
              this.enterQuantity(0, 1, false);
            }
            this.setState({ daysList: daysList, allDaysList: allDaysList });

            if (
              this.state.ProductCategoryList != null &&
              this.state.ProductCategoryList.length > 0 &&
              badgeDetails["ChapterIDs"]
            ) {
              const getCategoryIdArray = badgeDetails["ChapterIDs"].split(",");
              const newCategoryArray = [];
              getCategoryIdArray.forEach((categoryId) => {
                const found = this.state.ProductCategoryList.find(
                  item => item.value == categoryId.trim()
                );
                if (found) {
                  newCategoryArray.push({
                    label: found.label,
                    value: found.value,
                  });
                }
              });
              this.setState({ category: newCategoryArray });

              this.setState(prevState => {
                const newID = prevState.exhbitorBadgeList.length + 1;
                return {
                  exhbitorBadgeList: [
                    ...prevState.exhbitorBadgeList,
                    {
                      ID: newID,
                      Name: badgeDetails["Name"] != null ? badgeDetails["Name"] : "",
                      Designation: badgeDetails["Designation"] != null
                        ? badgeDetails["Designation"]
                        : "",
                      countryid: badgeDetails["CountryID"] != null
                        ? badgeDetails["CountryID"]
                        : "",
                      CompanyName: badgeDetails["CompanyName"] != null
                        ? badgeDetails["CompanyName"]
                        : "",
                      Remark: badgeDetails["Remarks"] != null ? badgeDetails["Remarks"] : "",
                      companyName:
                        badgeDetails["CompanyName"] != null
                          ? badgeDetails["CompanyName"]
                          : "",
                      VaccinationCertifcateFilePath: badgeDetails["VaccinationCertifcateFilePath"] != null
                        ? badgeDetails["VaccinationCertifcateFilePath"]
                        : "",
                      visitDaysList: list.map(item => ({
                        ...item,
                        ID: newID
                      })),

                      PhotoFilePath: null,
                      PhotoIDFilePath: null,
                      vaccineCertificateFileType: null,
                      DocNo: null,
                      MobileNo: badgeDetails["MobileNo"] != null ? badgeDetails["MobileNo"] : "",
                      Email: badgeDetails["Email"] != null ? badgeDetails["Email"] : "",
                      IsPaid: this.state.UnPaid,
                      City: badgeDetails["City"] != null ? badgeDetails["City"] : "",
                      State: badgeDetails["State"] != null ? badgeDetails["State"] : "",
                      IsIGST: badgeDetails["IsIGST"] || false,

                      ExhBadgesProductCategoryList: newCategoryArray.map(item => ({
                        ...item,
                        ID: newID
                      })),

                      PriceList: this.state.PriceList.map(item => ({
                        ...item,
                        ID: newID,
                        Rates: data.data[0][0]['Rates'],
                        Amount: item.Quantity * data.data[0][0]['Rates'],
                        exhibitorName: badgeDetails["Name"] != null ? badgeDetails["Name"] : ""
                      })),

                      allDaysList,
                      daysList,
                      isEdit: false
                    }
                  ],
                };
              });
            }

          }, 500);

          console.log("getExhibitorBadgeDetails---------->", data.data);
          this.setState({
            isLoading: false,
            exhibitorName:
              badgeDetails["Name"] != null ? badgeDetails["Name"] : "",
            designation:
              badgeDetails["Designation"] != null
                ? badgeDetails["Designation"]
                : "",
            country:
              badgeDetails["CountryName"] != null
                ? badgeDetails["CountryName"]
                : "",
            countryId:
              badgeDetails["CountryID"] != null
                ? badgeDetails["CountryID"]
                : "",
            companyName:
              badgeDetails["CompanyName"] != null
                ? badgeDetails["CompanyName"]
                : "",
            remarks:
              badgeDetails["Remarks"] != null ? badgeDetails["Remarks"] : "",
            mobileNo:
              badgeDetails["MobileNo"] != null ? badgeDetails["MobileNo"] : "",
            email: badgeDetails["Email"] != null ? badgeDetails["Email"] : "",
            cityName: badgeDetails["City"] != null ? badgeDetails["City"] : "",
            stateName:
              badgeDetails["State"] != null ? badgeDetails["State"] : "",
            filePath:
              badgeDetails["VaccinationCertifcateFilePath"] != null
                ? badgeDetails["VaccinationCertifcateFilePath"]
                : "",
          });


        } else {
          this.setState({ isLoading: false });
          toastError(data.msg);
        }
      })
      .catch((err) => {
        console.log(err);
      });
  }

  // get Fill List
  async getFillList(actionID, exhibitionID, moduleID, keyValue, value, from) {
    const { } = this.state;
    this.setState({ isLoading: true });
    this.props
      .fill_action(actionID, exhibitionID, moduleID, keyValue, value)
      .then((data) => {
        if (data.error != 1) {
          if (actionID == ProductCategoryActionId) {
            this.setState({
              isLoading: false,
              primaryChapterList: data.data,
              isShowVaccination: data.data[0]["isShowVaccination"],
            });
          }

          if (actionID == mainChapterListActionId) {
            var tempCityArr = [];
            for (var i = 0; i < data.data.length; i++) {
              var cityObj = {};
              cityObj.value = data.data[i].ChapterID;
              cityObj.label = data.data[i].ChapterName;
              tempCityArr.push(cityObj);
            }
            const list = [];
            if (this.state.primaryChapterList != "") {
              for (let i = 0; i < this.state.primaryChapterList.length; i++) {
                for (let j = 0; j < tempCityArr.length; j++) {
                  if (
                    this.state.primaryChapterList[i]["PrimaryChapter"] ==
                    tempCityArr[j]["value"]
                  ) {
                    list.push(tempCityArr[j]);
                  }
                }
              }
            }
            if (
              this.props.location.state != null &&
                this.props.location.state.is_add
                ? this.props.location.state.is_add
                : false
            ) {
              this.setState({ category: list });
            }
            this.setState({
              ProductCategoryList: tempCityArr,
              isLoading: false,
            });
          }
          // Country List
          if (actionID === countryActionId) {
            console.log("country data", data.data);
            this.setState({
              countryList: data.data,
              tempCountryList: data.data,
              isLoading: false,
            });
          }
          if (actionID === exhibitorBadgeVisitDaysActionId) {
            console.log("exhibitor data", data.data);

            var allDaysLists = [
              {
                Code: "all",
                description: "All Days",
                isSelect:
                  this.props.location.state != null &&
                    (this.props.location.state.is_update ||
                      this.props.location.state.is_View)
                    ? false
                    : true,
                isReadOnly: false,
              },
            ];
            var DateList = [];
            data.data.map((item) => {
              var mapData = {
                Code: item["DateValue"],
                description: item["DateValue"],
                isSelect: false,
                isReadOnly:
                  this.props.location.state != null &&
                    (this.props.location.state.is_update ||
                      this.props.location.state.is_View)
                    ? false
                    : true,
              };
              DateList.push(mapData);
            });
            this.setState(
              {
                allDaysList: allDaysLists,
                daysList: DateList,
                isLoading: false,
              },
              () => {
                this.enterQuantity(1, 0, true);
                this.enterQuantity(0, 1, false);
              }
            );
          }

          // state list
          if (actionID === stateActionId) {
            this.setState({
              stateList: data.data,
              tempStateList: data.data,
              isLoading: false,
            });
          }

          // city list
          if (actionID === cityActionId) {
            this.setState({
              cityList: data.data,
              tempCityList: data.data,
              isLoading: false,
            });
          }
        } else {
          this.setState({ isLoading: false });
          toastError(data.msg);
        }
      })
      .catch((err) => {
        console.log(err);
      });
  }

  // render city
  renderCityList() {
    const { cityList, cityName, tempCityList } = this.state;
    return (
      <ul
        class="list-group pincode-drop"
        style={{ position: "absolute", zIndex: 1 }}
      >
        {tempCityList.length > 0 &&
          tempCityList.map((data) => (
            <li
              class="list-group-item"
              key={Math.random()}
              onClick={(e) =>
                this.setState({
                  cityName: data.Description,
                  isDisplayCityList: false,
                })
              }
            >
              {data.Description}
            </li>
          ))}
      </ul>
    );
  }
  // searcg city
  onCitySearch(e) {
    const { cityList, cityName, tempCityList, countryId } = this.state;
    if (countryId == 91) {
      if (e.target.value != "") {
        var searchCityList = tempCityList.filter((data) => {
          return data.Description.toLowerCase().includes(
            e.target.value.toLowerCase()
          );
        });
        this.setState({
          cityName: e.target.value,
          cityNameErr: "",
          tempCityList: searchCityList,
          isDisplayCityList: true,
        });
        // call state fill list pass city id
        //this.getFillList(stateActionId,"","",)
      } else {
        this.setState({
          cityName: e.target.value,
          tempCityList: cityList,
          isDisplayCityList: false,
        });
      }
    } else {
      this.setState({
        cityName: e.target.value,
        tempCityList: cityList,
        isDisplayCityList: false,
        cityNameErr: "",
      });
    }
  }
  // state list
  callStateList(value, id) {
    const { stateList, stateName, tempStateList } = this.state;
    this.setState({ stateName: value, stateId: id, isDisplayStateList: false });
    this.getFillList(stateActionId, "", "", "", stateName, "", "");
  }

  // render state
  renderStateList() {
    const { stateList, stateName, tempStateList } = this.state;
    return (
      <ul
        class="list-group pincode-drop"
        style={{ position: "absolute", zIndex: 1 }}
      >
        {tempStateList.length > 0 &&
          tempStateList.map((data) => (
            <li
              class="list-group-item"
              key={Math.random()}
              onClick={(e) => this.callStateList(data.Description, data.Code)}
            >
              {data.Description}
            </li>
          ))}
      </ul>
    );
  }
  // search state
  onStateSearch(e) {
    const { stateList, stateName, tempStateList, countryId } = this.state;
    console.log("onStateSearch");
    if (countryId == 91) {
      if (e.target.value != "") {
        var searchStateList = tempStateList.filter((data) => {
          return data.Description.toLowerCase().includes(
            e.target.value.toLowerCase()
          );
        });
        this.setState({
          stateName: e.target.value,
          stateNameErr: "",
          tempStateList: searchStateList,
          isDisplayStateList: true,
        });
        // call pincode fill list pass city id and state id
        // this.getFillList(pincodeActionId, '', '', '', stateName, '')
      } else {
        this.setState({
          stateName: e.target.value,
          tempStateList: stateList,
          isDisplayStateList: false,
        });
      }
    } else {
      this.setState({
        stateName: e.target.value,
        tempStateList: stateList,
        isDisplayStateList: false,
        stateNameErr: "",
      });
    }
  }

  // On cancel Click
  OnCancel() {
    // this.props.navigate('/exhibitorbadge')
    const { StatusID } = this.state;
    const from =
      this.props.location.state != null &&
        this.props.location.state.from != null
        ? this.props.location.state.from
        : "";
    const DeadlineDate = this.props.location.state?.DeadlineDate || null;
    const ActualDeadline = this.props.location.state?.ActualDeadline || null;
    const ManualFormsID = this.props.location.state?.ManualFormsID || null;
    const ServiceID = this.props.location.state?.ServiceID || null;
    const VendorDetails = this.props.location.state?.VendorDetails || {};
    if (from == "vendor") {
      this.props.navigate("/VendorModule", {
        state: { companyName: "", ManualFormsID, ServiceID, VendorDetails },
      });
    } else {
      this.props.navigate("/exhibitorbadge", {
        state: {
          Deadline: DeadlineDate,
          ActualDeadline: ActualDeadline,
          StatusID: StatusID,
          ManualFormsID,
          ServiceID,
          VendorDetails,
        },
      });
    }
  }

  // Input Fields Validation
  inputValidate() {
    const {
      exhibitorName,
      designation,
      country,
      category,
      companyName,
      countryId,
      cityName,
      stateName,
      mobileNo,
      email,
    } = this.state;
    if (exhibitorName == "") {
      this.setState({ exhibitorNameErr: "Please Enter Exhibitor Name" });
    }
    if (designation == "") {
      this.setState({ designationErr: "Please Enter Designation" });
    }
    if (countryId == "" || countryId == null || countryId == "Select") {
      this.setState({ countryErr: "Please Select Country" });
    }
    if (category == "") {
      this.setState({ categoryErr: "Please Enter Category" });
    }
    if (companyName == "") {
      this.setState({ companyNameErr: "Please Enter Company Name" });
    }
    if (cityName == "" || cityName == null) {
      this.setState({ cityNameErr: "Please Enter City" });
    }
    if (mobileNo == "" || mobileNo == null) {
      this.setState({ mobileNoErr: "Please Enter Mobile No" });
    }
    if (email == "" || email == null) {
      this.setState({ emailErr: "Please Enter Email" });
    }
    if (countryId == 91) {
      if (stateName == "" || stateName == null) {
        this.setState({ stateNameErr: "Please Enter State" });
      }
    }
  }

  inputValidateListData(i) {
    const { exhbitorBadgeList } = this.state;
    let hasError = false;

    exhbitorBadgeList.forEach((item, index) => {
      if (index === i) {

        // Reset previous errors (important)
        item.NameErr = "";
        item.DesignationErr = "";
        item.countryErr = "";
        item.CategoryErr = "";
        item.CompanyNameErr = "";
        item.CityErr = "";
        item.MobileNoErr = "";
        item.EmailErr = "";
        item.StateErr = "";

        if (item.Name === "") {
          item.NameErr = "Please Enter Exhibitor Name";
          hasError = true;
        }

        if (item.Designation === "") {
          item.DesignationErr = "Please Enter Designation";
          hasError = true;
        }

        if (!item.countryid || item.countryid === "Select") {
          item.countryErr = "Please Select Country";
          hasError = true;
        }

        if (!item.ExhBadgesProductCategoryList || item.ExhBadgesProductCategoryList.length === 0) {
          item.ExhBadgesProductCategoryListErr = "Please Select Category";
          hasError = true;
        }

        if (item.CompanyName === "") {
          item.CompanyNameErr = "Please Enter Company Name";
          hasError = true;
        }

        if (!item.City) {
          item.CityErr = "Please Enter City";
          hasError = true;
        }

        if (!item.MobileNo) {
          item.MobileNoErr = "Please Enter Mobile No";
          hasError = true;
        }

        if (!item.Email) {
          item.EmailErr = "Please Enter Email";
          hasError = true;
        }

        if (item.countryid === 91) {
          if (!item.State) {
            item.StateErr = "Please Enter State";
            hasError = true;
          }
        }
      }
    });

    this.setState({ exhbitorBadgeList });

    return hasError; // ✅ true if any error exists
  }

  // Search Country
  onCountrySearch(e) {
    const { countryList, tempCountryList } = this.state;
    this.setState({ country: "" });
    if (e.target.value != "") {
      var searchCoutryList = tempCountryList.filter((data) => {
        return data.Description.toLowerCase().includes(
          e.target.value.toLowerCase()
        );
      });

      this.setState({
        country: e.target.value,
        countryErr: "",
        tempCountryList: searchCoutryList,
        isDisplayCountryList: true,
      });
    } else {
      this.setState({
        country: e.target.value,
        tempCountryList: countryList,
        isDisplayCountryList: false,
      });
    }

  }

  // render Country
  renderCountryList() {
    const { tempCountryList } = this.state;
    return (
      <ul
        class="list-group pincode-drop"
        style={{ position: "absolute", zIndex: 1 }}
      >
        {tempCountryList.length > 0 &&
          tempCountryList.map((data) => (
            <li
              class="list-group-item"
              key={Math.random()}
              onClick={(e) =>
                this.setState({
                  country: data.Description,
                  countryId: data.Code,
                  isDisplayCountryList: false,
                })
              }
            >
              {data.Description}
            </li>
          ))}
      </ul>
    );
  }

  enterQuantity(e, index, IsShow) {
    const event = Number(e) || 0;

    /* =======================
       ADD / DEFAULT MODE
       (Already working – KEEP)
    ======================= */
    const { PriceList } = this.state;
    const list = [...PriceList];

    for (let i = 0; i < list.length; i++) {
      if (i === index) {
        list[i].Quantity = event;
        list[i].IsShow = IsShow;
        list[i].Amount = event ? event * list[i].Rates : 0;
      }
    }

    this.setState({ PriceList: list });

    /* =======================
       UPDATE MODE ONLY
       (Single badges)
    ======================= */
    if (this.state.isUpdate) {
      this.setState(prevState => {
        if (!prevState.exhbitorBadgeList.length) return null;

        const exhbitorBadgeList = [...prevState.exhbitorBadgeList];

        // update FIRST (and only) badges in update mode
        const row = { ...exhbitorBadgeList[0] };

        const updatedPriceList = row.PriceList.map((item, i) => {
          if (i !== index) return item;
          return {
            ...item,
            Quantity: event,
            IsShow,
            Amount: event ? event * item.Rates : 0
          };
        });

        exhbitorBadgeList[0] = {
          ...row,
          PriceList: updatedPriceList
        };

        return { exhbitorBadgeList };
      });
    }
  }

  checkDuplicates(array, keys) {
    const seen = new Set();
    const duplicates = [];

    for (let i = 0; i < array.length; i++) {
      const obj = array[i];
      const compositeKey = keys.map((k) => obj[k]).join("|");

      if (seen.has(compositeKey)) {
        duplicates.push({ index: i, values: compositeKey });
      } else {
        seen.add(compositeKey);
      }
    }

    if (duplicates.length > 0) {
      return true;
    } else {
      return false;
    }
  }

  AddBadges() {
    const {
      exhibitorName,
      designation,
      country,
      category,
      companyName,
      exhibitorNameErr,
      designationErr,
      countryErr,
      categoryErr,
      companyNameErr,
      remarks,
      vaccineCertificateFile,
      countryId,
      daysList,
      allDaysList,
      vaccineCertificateFileType,
      badgeLength,
      email,
      emailErr,
      mobileNo,
      mobileNoErr,
      UnPaid,
      DeadlineDate,
      stateNameErr,
      cityNameErr,
      cityName,
      stateName,
      PriceList
    } = this.state;
    // input validation
    this.inputValidate();
    var allDays = [...allDaysList, ...daysList];
    // console.log("allDays--->", allDays)
    const selectedDays = allDays.filter((data) => data.isSelect == true);
    // console.log("selectedDays--->", selectedDays)

    // preparing Selected Days for udt
    const ManualFormsID = this.props.location.state?.ManualFormsID || null;
    const ServiceID = this.props.location.state?.ServiceID || null;
    const VendorDetails = this.props.location.state?.VendorDetails || {};
    var list = [];
    selectedDays.map((data) => {
      var data = {
        visitDay: data.description,
      };
      list.push(data);
    });
    if (
      exhibitorName != "" &&
      designation != "" &&
      countryId != "" &&
      category.length > 0 &&
      category != "" &&
      companyName != "" &&
      cityName != "" &&
      cityName != null &&
      mobileNo != "" &&
      mobileNo != null && // ADD 
      email != "" && // ADD THIS
      email != null &&
      (countryId == 91 ? stateName != "" && stateName != null : true)
    ) {
      if (
        exhibitorNameErr == "" &&
        designationErr == "" &&
        countryErr == "" &&
        categoryErr == "" &&
        companyNameErr == "" &&
        emailErr == "" &&
        mobileNoErr == "" &&
        (sessionStorage.getItem("CurrencyID") == 1 ? stateNameErr == "" : true) &&
        cityNameErr == ""
      ) {
        if (selectedDays.length === 0) {
          toastError("Please Select Date");
          return;
        }
        const normalize = (value = "") =>
          value.toString().trim().toLowerCase();

        // check duplicate BEFORE setState
        const isDuplicate = this.state.exhbitorBadgeList.some(item =>
          normalize(item.Name) === normalize(exhibitorName) &&
          normalize(item.MobileNo) === normalize(mobileNo) &&
          normalize(item.Designation) === normalize(designation) &&
          normalize(item.Email) === normalize(email)
        );

        if (isDuplicate) {
          toastError(
            "Exhibitor badges data has already been created for this exhibitor!"
          );
          return;
        }

        this.setState(prevState => {
          const newID = prevState.exhbitorBadgeList.length + 1; // safer unique ID

          return {
            exhbitorBadgeList: [
              ...prevState.exhbitorBadgeList,
              {
                ID: newID,
                Name: exhibitorName,
                Designation: designation,
                countryid: countryId,
                CompanyName: companyName,
                Remark: remarks,
                VaccinationCertifcateFilePath: vaccineCertificateFile,

                visitDaysList: list.map(item => ({
                  ...item,
                  ID: newID
                })),

                PhotoFilePath: null,
                PhotoIDFilePath: null,
                vaccineCertificateFileType,
                DocNo: badgeLength,
                MobileNo: mobileNo,
                Email: email,
                IsPaid: UnPaid ? 0 : 1,
                City: cityName,
                State: stateName,

                ExhBadgesProductCategoryList: category.map(item => ({
                  ...item,
                  ID: newID
                })),

                ManualFormsID,
                ServiceID,
                VendorDetail: VendorDetails,

                PriceList: PriceList.map(item => ({
                  ...item,
                  ID: newID,
                  exhibitorName
                })),

                allDaysList: allDaysList.map(item => ({
                  ...item,
                  ID: newID,
                })),
                daysList: daysList.map(item => ({
                  ...item,
                  ID: newID,
                })),
                isEdit: false
              }
            ],

            exhibitorName: "",
            designation: "",
            mobileNo: "",
            email: ""
          };
        }, () => {
          toastSuccess("Exhibitor Badge Added Successfully");
        });

      } else {
        toastError("Please Enter Mandatory Fields");
      }
    } else {
      toastError("Please Enter Mandatory Fields");
    }
  }

  // Submit Exhibitor Badges
  onSubmitExhibitorBadge() {
    const { exhbitorBadgeList } = this.state;

    // preparing Selected Days for udt
    const ManualFormsID = this.props.location.state?.ManualFormsID || null;
    const ServiceID = this.props.location.state?.ServiceID || null;
    const VendorDetails = this.props.location.state?.VendorDetails || {};

    const array1 = []
    const array2 = []
    const array3 = []
    const array4 = []
    exhbitorBadgeList.forEach(item => {
      array1.push(
        {
          TempID: item.ID,
          Name: item.Name,
          Designation: item.Designation,
          CountryID: item.countryid,
          CompanyName: item.CompanyName,
          Remark: item.Remark,
          VaccinationCertifcateFilePath: item.VaccinationCertifcateFilePath,
          PhotoFilePath: null,
          PhotoIDFilePath: null,
          vaccineCertificateFileType: item.vaccineCertificateFileType,
          DocNo: item.DocNo,
          MobileNo: item.MobileNo,
          Email: item.Email,
          IsPaid: item.IsPaid,
          City: item.City,
          State: item.State,
        }
      )
      item.ExhBadgesProductCategoryList.forEach(obj => {
        array2.push({
          TempID: obj.ID,
          value: obj.value,
        })
      })
      const allDays = [...item.allDaysList, ...item.daysList];
      const selectedDays = allDays.filter((data) => data.isSelect == true);
      // preparing Selected Days for udt
      const list = [];
      selectedDays.map((obj) => {
        array3.push({
          TempID: obj.ID,
          visitDay: obj.description,
        })
      });

      array4.push(...item.PriceList)

    })
    if (exhbitorBadgeList.length > 0) {
      this.setState({ isLoading: true });
      this.props
        .addExhibitorBadge_action(
          array1,
          array2,
          array3,
          ManualFormsID,
          ServiceID,
          VendorDetails,
          array4
        )
        .then((data) => {
          if (data.error != 1) {
            toastSuccess("Exhibitor Badges Added Successfully");
            setTimeout(() => {
              this.setState({ isLoading: false });
              this.OnCancel();
            }, 1000);
          } else {
            this.setState({ isLoading: false });
            toastError(data.msg);
          }
        })
        .catch((err) => {
          console.log(err);
        });
    } else {
      toastError("Please add atleast 1 badges");
    }
  }

  // Update Exhibitor Badges
  onUpdateExhibitorBadge() {
    const {
      allDaysList,
      daysList,
      exhibitorName,
      designation,
      country,
      category,
      companyName,
      exhibitorNameErr,
      designationErr,
      countryErr,
      companyNameErr,
      categoryErr,
      countryId,
      remarks,
      vaccineCertificateFile,
      vaccineCertificateFileType,
      exBadgeFormId,
      email,
      emailErr,
      mobileNo,
      mobileNoErr,
      UnPaid,
      cityName,
      stateName,
      exhbitorBadgeList
    } = this.state;

    const ManualFormsID = this.props.location.state?.ManualFormsID || null;
    const ServiceID = this.props.location.state?.ServiceID || null;
    const VendorDetails = this.props.location.state?.VendorDetails || {};

    const array1 = []
    const array2 = []
    exhbitorBadgeList.forEach(item => {
      array1.push(
        {
          TempID: item.ID,
          Name: item.Name,
          Designation: item.Designation,
          CountryID: item.countryid,
          CompanyName: item.CompanyName,
          Remark: item.Remark,
          VaccinationCertifcateFilePath: item.VaccinationCertifcateFilePath,
          PhotoFilePath: null,
          PhotoIDFilePath: null,
          vaccineCertificateFileType: item.vaccineCertificateFileType,
          DocNo: item.DocNo,
          MobileNo: item.MobileNo,
          Email: item.Email,
          IsPaid: item.IsPaid,
          City: item.City,
          State: item.State,
        }
      )
      array2.push(...item.PriceList)
    })

    // Input Validation
    this.inputValidate();

    var allDays = [...allDaysList, ...daysList];
    const selectedDays = allDays.filter((data) => data.isSelect == true);
    // preparing Selected Days for udt
    var list = [];
    selectedDays.map((data) => {
      var data = {
        visitDay: data.description,
      };
      list.push(data);
    });
    console.log("list------------>", list);
    if (
      exhibitorName != "" &&
      designation != "" &&
      countryId != "" &&
      category.length > 0 &&
      category != "" &&
      companyName != "" &&
      cityName != "" &&
      cityName != null &&
      (countryId == 91 ? stateName != "" && stateName != null : true)
    ) {
      if (
        exhibitorNameErr == "" &&
        designationErr == "" &&
        countryErr == "" &&
        categoryErr == "" &&
        companyNameErr == "" &&
        mobileNoErr == "" &&
        emailErr == ""
      ) {
        if (selectedDays.length > 0) {
          this.setState({ isLoading: true });
          this.props
            .updateExhibitorBadge_action(
              exBadgeFormId,
              exhibitorName,
              designation,
              countryId,
              companyName,
              remarks,
              vaccineCertificateFile,
              list,
              vaccineCertificateFileType,
              mobileNo,
              email,
              UnPaid ? 0 : 1,
              cityName,
              stateName,
              category,
              ManualFormsID,
              ServiceID,
              VendorDetails,
              array1,
              array2
            )
            .then((data) => {
              if (data.error != 1) {
                console.log("updateExhibitorBadge----------->", data.data);
                toastSuccess("Exhibitor Badges Updated Successfully");
                setTimeout(() => {
                  this.setState({ isLoading: false });
                  this.OnCancel();
                }, 1000);
              } else {
                this.setState({ isLoading: false });
                toastError(data.msg);
              }
            })
            .catch((err) => {
              console.log(err);
            });
        } else {
          toastError("Please Select Date");
        }
      } else {
        toastError("Please Enter Mandatory Fields");
      }
    } else {
      toastError("Please Enter Mandatory Fields");
    }
  }

  onFilePick = async (e, file) => {
    e.preventDefault();
    console.log("File01010101------", file);
    const { } = this.state;
    if (file[0]["size"] >= 5 * 1024 * 1024) {
      toastError("File size more than 5mb are not allow.");
    } else {
      var image = "";
      if (
        file[0]["name"].toString().toLowerCase().includes(".pdf") ||
        file[0]["name"].toString().toLowerCase().includes(".jpeg") ||
        file[0]["name"].toString().toLowerCase().includes(".png") ||
        file[0]["name"].toString().toLowerCase().includes(".jpg")
      ) {
        if (
          file[0]["name"].toString().toLowerCase().trim().includes(".jpg") ||
          file[0]["name"].toString().toLowerCase().trim().includes(".png") ||
          file[0]["name"].toString().toLowerCase().trim().includes(".jpeg")
        ) {
          image = await this.resizeFile(file[0]);
          this.setState({ vaccineCertificateFile: image });
        } else if (
          file[0]["name"].toString().toLowerCase().trim().includes(".pdf")
        ) {
          image = await this.onPdfSelect(file[0]);
          this.setState({ vaccineCertificateFile: image });
        }

        var fileType = file[0]["type"];
        var fileTypeList;
        if (fileType.includes("/")) {
          fileTypeList = fileType.split("/");
        }
        this.setState({
          vaccineCertificateFileType:
            fileTypeList.length > 0 ? fileTypeList[1] : "",
        });
      } else {
        toastError("Only .pdf , .jpeg, .png, .jpg files are allowed");
      }
    }
  };

  onPdfSelect = (file) =>
    new Promise((resolve) => {
      let base64;
      // FileReader function for read the file.
      let fileReader = new FileReader();
      // Onload of file read the file content
      fileReader.onload = function (fileLoadedEvent) {
        base64 = fileLoadedEvent.target.result;
        // Print data in console
        resolve(base64);
      };
      // Convert data to base64
      fileReader.readAsDataURL(file);
    });

  resizeFile = (file) =>
    new Promise((resolve) => {
      Resizer.imageFileResizer(
        file,
        500,
        600,
        "JPEG",
        80,
        0,
        (uri) => {
          resolve(uri);
        },
        "base64",
        300,
        300
      );
    });

  // On Select Days
  onSelectDates(e, i) {
    const { allDaysList, daysList } = this.state;
    console.log("daysList", e.target.checked, i);
    var code = e.target.checked;
    var isThreelDatesChecked = false;
    daysList.map((data, index) => {
      if (index == i) {
        data.isSelect = code;
      }
    });
    var allDaySelected = daysList.every((data) => data.isSelect == true);

    if (allDaySelected) {
      isThreelDatesChecked = true;
    } else {
      isThreelDatesChecked = false;
    }

    if (isThreelDatesChecked) {
      allDaysList.length > 0 &&
        allDaysList.map((data) => {
          data.isSelect = true;
        });
      daysList.map((item) => {
        item.isSelect = false;
        item.isReadOnly = true;
      });
    }
    console.log("allDaysList", allDaysList);
    const list = daysList.filter((item) => item.isSelect);
    if (allDaySelected) {
      this.enterQuantity(1, 0, true);
      this.enterQuantity(0, 1, false);
    } else {
      this.enterQuantity(0, 0, false);
      this.enterQuantity(list.length, 1, true);
    }
    this.setState({ allDaysList: allDaysList, daysList: daysList });
  }

  // On Select all Days
  onSelectAllDates(e) {
    const { allDaysList, daysList, isUpdate, exhbitorBadgeList } = this.state;
    console.log("daysList", e.target.value, e.target.checked, daysList);
    allDaysList.length > 0 &&
      allDaysList.map((data) => {
        if (e.target.checked) {
          data.isSelect = true;
          daysList.map((item) => {
            item.isSelect = false;
            item.isReadOnly = true;
          });
        } else {
          data.isSelect = false;
          daysList.map((item) => {
            // item.isSelect = !item.isSelect
            item.isReadOnly = false;
            // console.log("item", item)
          });
        }
      });
    if (e.target.checked) {
      this.enterQuantity(1, 0, true);
      this.enterQuantity(0, 1, false);
    } else {
      this.enterQuantity(0, 0, true);
      this.enterQuantity(0, 1, false);
    }

    this.setState({
      allDaysList: allDaysList,
      daysList: daysList,
      isAllCount: e.target.checked ? daysList.length : 0,
    });
  }

  // on Cross click
  onCrossClick() {
    this.setState({ vaccineCertificateFile: "" });
    document.getElementById("vaccFile").value = "";
  }

  // On Document Delete Modal Toggle
  onDocDelete() {
    const { isDelOpen } = this.state;
    this.setState({ isDelOpen: !isDelOpen });
  }

  // Delete Exhibitor BAdges Document Delete
  handleDelete(e) {
    e.preventDefault();
    const { isDelOpen, exBadgeFormId, vaccFileName } = this.state;
    this.setState({ isLoading: true });
    this.props
      .deleteExBadgeDoc_action(exBadgeFormId)
      .then((data) => {
        if (data.error != 1) {
          toastSuccess("Exhibitor Badges Document Deleted SuccessFully");
          this.setState({
            isLoading: false,
            isDelOpen: !isDelOpen,
            vaccFileName: "",
          });
        } else {
          toastError(data.msg);
          this.setState({ isLoading: false });
        }
      })
      .catch((error) => {
        console.log(error);
      });
  }

  // Mobile No Validation
  mobileValidation(e) {
    const { countryId } = this.state;
    var mobileError;
    if (countryId == 91) {
      mobileError = mobileNoValidator(e.target.value);
    } else {
      mobileError = "";
    }
    this.setState({ mobileNo: e.target.value.replace(/\D/g, "") });
    if (mobileError != "") {
      this.setState({ mobileNoErr: mobileError });
    } else {
      this.setState({ mobileNoErr: "" });
    }
  }

  // Email Validation
  emailValidation(e) {
    var emailError = emailValidator(e.target.value);
    this.setState({ email: e.target.value });
    if (emailError != "") {
      this.setState({ emailErr: emailError });
    } else {
      this.setState({ emailErr: "" });
    }
  }

  calculateTotals() {
    try {
      const { PriceList, exhbitorBadgeList } = this.state;
      let totalAmount = 0;
      exhbitorBadgeList.map((item) => {
        item.PriceList.forEach((data) => {
          totalAmount += Number(data.Amount);
        });
      })
      return {
        totalAmount,
      };
    } catch (e) {
      console.log("exception : ", e);
    }
  }

  handleSelectAllBadges(e) {
    const { exhbitorBadgeList } = this.state;
    const isChecked = e.target.checked;
    const updatedList = exhbitorBadgeList.map(item => ({
      ...item,
      is_checked: isChecked
    }));

    const selectedBadges = isChecked
      ? updatedList.filter(item => item.is_checked).map(item => ({
        ServiceID: item.ServiceID || item.ID,
        Amount: item.PriceList?.reduce((sum, p) => sum + (Number(p.Amount) || 0), 0) || 0
      }))
      : [];

    this.setState({ exhbitorBadgeList: updatedList, selectedBadges });
  }

  handleBadgeCheckboxChange(e, index) {
    const { exhbitorBadgeList } = this.state;
    const isChecked = e.target.checked;
    exhbitorBadgeList[index].is_checked = isChecked;

    const selectedBadges = exhbitorBadgeList
      .filter(item => item.is_checked)
      .map(item => ({
        ServiceID: item.ServiceID || item.ID,
        Amount: item.PriceList?.reduce((sum, p) => sum + (Number(p.Amount) || 0), 0) || 0
      }));

    this.setState({ exhbitorBadgeList: [...exhbitorBadgeList], selectedBadges });
  }

  handleFieldChange = (rowIndex, fieldName, value) => {
    this.setState(prevState => {
      const exhbitorBadgeList = [...prevState.exhbitorBadgeList];
      exhbitorBadgeList[rowIndex] = {
        ...exhbitorBadgeList[rowIndex],
        [fieldName]: value,
        [`${fieldName}Err`]: ""
      };
      return { exhbitorBadgeList };
    });
  };

  handleEmailChange = (rowIndex, e) => {
    const value = e.target.value;
    const regex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

    this.setState(prevState => {
      const list = [...prevState.exhbitorBadgeList];
      list[rowIndex].Email = value;
      list[rowIndex].EmailErr = regex.test(value)
        ? ""
        : "Please enter valid email";
      return { exhbitorBadgeList: list };
    });
  };

  handleMobileChange = (rowIndex, e) => {
    const value = e.target.value.replace(/\D/g, "");

    this.setState(prevState => {
      const list = [...prevState.exhbitorBadgeList];
      list[rowIndex].MobileNo = value;
      list[rowIndex].MobileNoErr = value
        ? ""
        : "Please Enter Mobile No";
      return { exhbitorBadgeList: list };
    });
  };

  handleDayChange = (rowIndex, dayIndex, checked) => {
    this.setState(prevState => {
      const exhbitorBadgeList = [...prevState.exhbitorBadgeList];
      const row = { ...exhbitorBadgeList[rowIndex] };

      // update selected day
      const daysList = row.daysList.map((day, i) =>
        i === dayIndex ? { ...day, isSelect: checked } : day
      );

      // check if all days are selected
      const isAllSelected = daysList.every(d => d.isSelect);

      // update all-days checkbox
      const allDaysList = row.allDaysList.map(d => ({
        ...d,
        isSelect: isAllSelected
      }));

      // when all individual days selected → lock them
      const updatedDaysList = daysList.map(d => ({
        ...d,
        isReadOnly: isAllSelected,
        isSelect: isAllSelected ? false : d.isSelect
      }));

      // quantity logic
      if (isAllSelected) {
        this.updateBadgePriceQuantity(rowIndex, 1, 0, true);   // All Day
        this.updateBadgePriceQuantity(rowIndex, 0, 1, false);  // Single Day

      } else {
        const selectedCount = updatedDaysList.filter(d => d.isSelect).length;

        this.updateBadgePriceQuantity(rowIndex, selectedCount, 1, true);
        this.updateBadgePriceQuantity(rowIndex, 0, 0, false);

      }

      exhbitorBadgeList[rowIndex] = {
        ...row,
        daysList: updatedDaysList,
        allDaysList
      };
      console.log("exhbitorBadgeList----------------------------------------->", exhbitorBadgeList)
      return { exhbitorBadgeList };
    });
  };

  handleAllDaysChange = (rowIndex, checked) => {
    this.setState(prevState => {
      const exhbitorBadgeList = [...prevState.exhbitorBadgeList];
      const row = { ...exhbitorBadgeList[rowIndex] };

      // update all days checkbox
      const allDaysList = row.allDaysList.map(d => ({
        ...d,
        isSelect: checked
      }));

      // update individual days
      const daysList = row.daysList.map(d => ({
        ...d,
        isSelect: false,
        isReadOnly: checked
      }));
      console.log("checked----------->", checked)
      // quantity logic
      if (checked) {
        this.updateBadgePriceQuantity(rowIndex, 1, 0, true);
        this.updateBadgePriceQuantity(rowIndex, 0, 1, false);
      } else {
        this.updateBadgePriceQuantity(rowIndex, 0, 0, true);
        this.updateBadgePriceQuantity(rowIndex, 0, 1, false);
      }


      exhbitorBadgeList[rowIndex] = {
        ...row,
        allDaysList,
        daysList
      };

      return { exhbitorBadgeList };
    });
  };

  updateBadgePriceQuantity = (rowIndex, quantity, priceIndex, isShow) => {
    this.setState(prevState => {
      const exhbitorBadgeList = [...prevState.exhbitorBadgeList];
      const row = { ...exhbitorBadgeList[rowIndex] };

      const updatedPriceList = row.PriceList.map((item, i) => {
        if (i !== priceIndex) return item;

        const qty = Number(quantity) || 0;
        return {
          ...item,
          Quantity: qty,
          IsShow: isShow,
          Amount: qty * item.Rates
        };
      });

      exhbitorBadgeList[rowIndex] = {
        ...row,
        PriceList: updatedPriceList
      };

      return { exhbitorBadgeList };
    });
  };

  render() {
    const {
      isLoading,
      exhibitorName,
      designation,
      country,
      category,
      companyName,
      remarks,
      exhibitorNameErr,
      designationErr,
      countryErr,
      categoryErr,
      companyNameErr,
      isDisplayCountryList,
      daysList,
      allDaysList,
      isAdd,
      isUpdate,
      vaccineCertificateFile,
      vaccFileName,
      isDelOpen,
      isView,
      filePath,
      email,
      mobileNo,
      mobileNoErr,
      emailErr,
      countryId,
      UnPaid,
      isDisplayCityList,
      cityName,
      stateName,
      isDisplayStateList,
      countryList,
      cityNameErr,
      stateNameErr,
      ProductCategoryList,
      isShowVaccination,
      PriceList,
      CurrencyName,
      CGST,
      IGST,
      SGST,
      Is_View,
      StatusID,
      AllDayPrice,
      SingleDayPrice,
      exhbitorBadgeList,
      isHideSection, isOpenConfirmationModal,
      MaxUnpaidBadge, IsIGST, RoleID, exhBadgeStatusCountList, IsMixExhibitor, companyList
    } = this.state;
    const { totalAmount } = this.calculateTotals();
    const toInputUppercase = (e) => {
      e.target.value = ("" + e.target.value).toUpperCase();
    };
    console.log("PriceList--->", PriceList)
    return (
      <>
        {isOpenConfirmationModal ? <ConfirmationModal onConfirmation={this.handleConfirmation} message={this.state.confirmationObj} /> : null}
        {isLoading ? <Loader></Loader> : null}
        <ToastContainer />
        {JSON.parse(sessionStorage.getItem("loginDataSS")).RoleID == 1 ||
          JSON.parse(sessionStorage.getItem("loginDataSS")).RoleID == 8 ? (
          <ExhibitorHeader />
        ) : (
          <HeaderWithLogo />
        )}
        {JSON.parse(sessionStorage.getItem("loginDataSS")).RoleID == 1 ||
          JSON.parse(sessionStorage.getItem("loginDataSS")).RoleID == 8 ? (
          <ExhibitorDrawer />
        ) : JSON.parse(sessionStorage.getItem("loginDataSS")).RoleID == 7 ? (
          <VendorDrawer />
        ) : (
          <AdminDrawer />
        )}
        <div className={!isHideSection ? "with-dr-container mf-form" : ""} style={{ marginTop: RoleID == 1 ? "0px" : "" }}>
          <div className="main-container">
            {!isHideSection && (
              <div className="row">
                {JSON.parse(sessionStorage.getItem("loginDataSS")).RoleID ==
                  1 ||
                  JSON.parse(sessionStorage.getItem("loginDataSS")).RoleID ==
                  8 ? (
                  <ExhibitorTopMenu />
                ) : null}
              </div>
            )}
{/* Standard page title strip: form name + deadline, sticky under the tab bar */}
{!isHideSection && <ManualFormTitleStrip title={this.props.location?.state?.ManualFormsName || "Exhibitor Badges"} deadline={this.props.location?.state?.ActualDeadline} />}

            <div className="p-2 mt-2">
              <div className="row m-0">
                {!isHideSection &&
                  <div class="card rounded-1 border mt-7 p-0">
                    <div class="card-header mf-old-title">
                      <h3 className="card-title">
                        {" "}
                        {UnPaid ? "" : "Additional"} Exhibitor {UnPaid ? "" : "Paid"} Badges{" "}
                      </h3>
                    </div>
                    {!isHideSection &&
                      <div className="card-body p-0" >
                        <div class="card-body p-0 m-2">
                          <h6>Instructions:</h6>
                          <ol type="1)" style={{ textAlign: "left" }}>
                            <li>
                              This badges is entitled entry only person it is issued for{" "}
                              {sessionStorage.getItem("ExhibitionName")}
                            </li>
                            <li>
                              Kindly provide accurate information for each badges holder as it will appear on the printed badges.
                            </li>
                            <li>
                              Individuals below 18 Years strictly not allowed in exhibition hall.
                            </li>
                            <li>
                              Additional exhibitor badges will be charged at <strong>{CurrencyName == 'INR' ? 'INR' : 'USD'} {AllDayPrice ? Math.round(AllDayPrice * 1.18).toLocaleString() : ''}/per</strong> badges (including taxes).
                            </li>
                          </ol>
                        </div>

                        <div className="row mt-2">
                          <div class="table-responsive px-6">
                            <table class="table border text-nowrap text-md-nowrap table-bordered mb-0 mt-1">
                              <thead className="text-center">
                                <tr>
                                  <th>Allotted Quota</th>
                                  <th>Total Applied</th>
                                  <th>Approved</th>
                                  <th>Declined</th>
                                  <th>Additional Exhibitor Badges</th>
                                </tr>
                              </thead>
                              <tbody className="text-center">
                                {exhBadgeStatusCountList.length > 0 ?
                                  exhBadgeStatusCountList.map((item) => (
                                    <tr>
                                      <td>{item.AllottedQuota}</td>
                                      <td>{item.TotalApplied}</td>
                                      <td>{item.Approved}</td>
                                      <td>{item.Declined}</td>
                                      <td>{item.AdditionalExhibitorBadges}</td>
                                    </tr>
                                  )) :
                                  <tr>
                                    <td className="text-center" colSpan={15}>Record not found</td>
                                  </tr>
                                }

                              </tbody>
                            </table>
                          </div>
                        </div>

                        <div className="row mt-3">
                          {isShowVaccination && (
                            <div className="col-xl-4 mt-3">
                              <label htmlFor="validationCustom03">
                                Upload Fully Vaccination Certificate
                              </label>
                              <div className="box">
                                <div className="js--image-preview" />
                                {isAdd ? (
                                  <div className="upload-options">
                                    <label>
                                      <input
                                        type="file"
                                        id="vaccFile"
                                        className="image-upload"
                                        disabled={isView || StatusID == 2}
                                        accept=".jpg, .jpeg, .png, .pdf"
                                        onChange={(e) =>
                                          this.onFilePick(e, e.target.files)
                                        }
                                      />
                                      {vaccineCertificateFile != "" && (
                                        <i
                                          class="fa fa-times text-danger img-can"
                                          onClick={() => this.onCrossClick()}
                                        ></i>
                                      )}
                                    </label>
                                  </div>
                                ) : isUpdate || isView ? (
                                  vaccFileName != "" && vaccFileName != null ? (
                                    <div
                                      style={{
                                        border: "1px solid #ccc",
                                        padding: "10px",
                                        display: "inline-flex",
                                        alignItems: "center",
                                        marginTop: "10px",
                                      }}
                                    >
                                      <a
                                        href={filePath}
                                        target="_blank"
                                        rel="noopener noreferrer"
                                      >
                                        <span style={{ marginRight: "10px" }}>
                                          {vaccFileName}
                                        </span>
                                        <i
                                          className={`fa fa-times text-danger img-can ${isView ? "disabled" : ""
                                            }`}
                                          onClick={
                                            !isView
                                              ? (e) => this.onDocDelete()
                                              : undefined
                                          }
                                        ></i>
                                      </a>
                                    </div>
                                  ) : (
                                    <div className="upload-options">
                                      <label>
                                        <input
                                          type="file"
                                          id="vaccFile"
                                          className="image-upload"
                                          accept=".jpg, .jpeg, .png, .pdf"
                                          disabled={isView || StatusID == 2}
                                          onChange={(e) =>
                                            this.onFilePick(e, e.target.files)
                                          }
                                        />
                                        {vaccineCertificateFile != "" && (
                                          <i
                                            class="fa fa-times text-danger img-can ml-10"
                                            onClick={() => this.onCrossClick()}
                                          ></i>
                                        )}
                                      </label>
                                    </div>
                                  )
                                ) : (
                                  <></>
                                )}
                              </div>
                            </div>
                          )}

                        </div>
                      </div>}
                  </div>}



                <div className="card-body border">

                  <div className="row p-0">

                    <div className="col-xl-4">
                      <label htmlFor="validationCustom03">
                        Company Name
                        <span className="text-red">*</span>
                      </label>

                      {IsMixExhibitor ?
                        <select
                          className="form-control"
                          value={companyName}
                          disabled={isView || StatusID == 2}
                          onChange={(e) => {
                            this.setState({
                              companyName: e.target.value,
                              companyNameErr: "",
                            });
                          }
                          }
                        >
                          <option value={''}>Select</option>
                          {companyList.length > 0 &&
                            companyList.map((data) => (
                              <option key={data.CompanyName} value={data.CompanyName}>
                                {data.CompanyName}
                              </option>
                            ))}
                        </select> :
                        <input
                          type="text"
                          className="form-control"
                          id="validationCustom03"
                          disabled={true}
                          value={companyName}
                          onChange={(e) =>
                            this.setState({
                              companyName: e.target.value,
                              companyNameErr: "",
                            })
                          }
                        />
                      }

                    </div>

                    <div className="col-xl-4">
                      <label htmlFor="validationCustom03">
                        Exhibitor Name
                        <span className="text-red">*</span>
                      </label>
                      <input
                        type="text"
                        className="form-control"
                        id="validationCustom03"
                        maxLength={"100"}
                        placeholder="Enter Exhibitor Name"
                        disabled={isView || StatusID == 2}
                        value={exhibitorName}
                        // onInput={toInputUppercase}
                        onChange={(e) =>
                          this.setState({
                            exhibitorName: e.target.value,
                            exhibitorNameErr: "",
                          })
                        }
                      />
                      {
                        <span className="text-danger text-start text-left d-block mt-1">
                          {exhibitorNameErr}
                        </span>
                      }
                    </div>
                    <div className="col-xl-4">
                      <label htmlFor="validationCustom03">
                        Designation
                        <span className="text-red">*</span>
                      </label>
                      <input
                        type="text"
                        className="form-control"
                        id="validationCustom03"
                        maxLength={"50"}
                        placeholder="Enter Designation"
                        disabled={isView || StatusID == 2}
                        value={designation}
                        // onInput={toInputUppercase}
                        onChange={(e) =>
                          this.setState({
                            designation: e.target.value,
                            designationErr: "",
                          })
                        }
                      />
                      {
                        <span className="text-danger text-start text-left d-block mt-1">
                          {designationErr}
                        </span>
                      }
                    </div>
                    <div className="col-xl-4 mt-3">
                      <label>
                        Country<span className="text-red">*</span>
                      </label>
                      <select
                        className="form-control"
                        id="roledb"
                        // style={{ textAlign: "left" }}
                        disabled={isView || StatusID == 2}
                        value={countryId}
                        onChange={(e) =>
                          this.setState({
                            countryId: e.target.value,
                            cityName: "",
                            stateName: "",
                            isDisplayCityList: false,
                            isDisplayStateList: false,
                            countryErr: "",
                          })
                        }
                      >
                        <option>Select</option>
                        {countryList.length > 0 &&
                          countryList.map((data) => (
                            <option key={data.Code} value={data.Code}>
                              {data.Description}
                            </option>
                          ))}
                      </select>
                      {
                        <span className="text-danger text-start text-left d-block mt-1">
                          {countryErr}
                        </span>
                      }
                    </div>
                    <div className="col-xl-4 mt-3">
                      <label htmlFor="validationCustom01">
                        City<span className="text-red">*</span>
                      </label>
                      <input
                        type="text"
                        className="form-control"
                        disabled={isView || StatusID == 2}
                        required=""
                        value={cityName}
                        onChange={(e) => this.onCitySearch(e)}
                      />
                      {isDisplayCityList && this.renderCityList()}
                      {
                        <span className="text-danger text-start text-left d-block mt-1">
                          {cityNameErr}
                        </span>
                      }
                    </div>
                    <div className="col-xl-4 mt-3">
                      <label htmlFor="validationCustom01">
                        {countryId == 91 ? "State" : "State/Province"}
                        {countryId == 91 ? (
                          <span className="text-red">*</span>
                        ) : (
                          ""
                        )}
                      </label>
                      <input
                        type="text"
                        className="form-control"
                        disabled={isView || StatusID == 2}
                        required=""
                        value={stateName}
                        onChange={(e) => this.onStateSearch(e)}
                      />
                      {isDisplayStateList && this.renderStateList()}
                      {
                        <span className="text-danger text-start text-left d-block mt-1">
                          {stateNameErr}
                        </span>
                      }
                    </div>
                    <div className="col-xl-4 mt-3">
                      <label htmlFor="validationCustom03">
                        Email<span className="text-red">*</span>
                      </label>
                      <input
                        type="text"
                        className="form-control"
                        id="validationCustom03"
                        maxLength={"200"}
                        placeholder="Enter Email"
                        disabled={isView || StatusID == 2}
                        value={email}
                        onChange={(e) => this.emailValidation(e)}
                      // onChange={(e) => this.setState({ email: e.target.value })}
                      />
                      {
                        <span className="text-danger text-start text-left d-block mt-1">
                          {emailErr}
                        </span>
                      }
                    </div>
                    <div className="col-xl-4 mt-3">
                      <label htmlFor="validationCustom03">
                        Mobile No<span className="text-red">*</span>
                      </label>
                      <input
                        type="text"
                        className="form-control"
                        id="validationCustom03"
                        maxLength={countryId == 91 ? 10 : 12}
                        disabled={isView || StatusID == 2}
                        value={mobileNo}
                        onChange={(e) => this.mobileValidation(e)}
                      />
                      {
                        <span className="text-danger text-start text-left d-block mt-1">
                          {mobileNoErr}
                        </span>
                      }
                    </div>
                    <div className="col-xl-8 mt-3">
                      <label>
                        Category
                        <span class="text-red">*</span>
                      </label>
                      <Select
                        isMulti
                        // isDisabled={statusId == '0'}
                        // isClearable={statusId != '0'}
                        // styles={statusId == '0' ? deletedStyles : customStyles}
                        isDisabled={isView || StatusID == 2}
                        styles={customStyles}
                        value={category}
                        onChange={(e) =>
                          this.setState({ category: e, categoryErr: "" })
                        }
                        options={ProductCategoryList}
                      />
                      {
                        <span className="text-danger text-start text-left d-block mt-1">
                          {categoryErr}
                        </span>
                      }
                    </div>
                    <div className="col-xl-12 mt-3">
                      <label htmlFor="validationCustom03">Remarks</label>
                      <textarea
                        type="text"
                        className="form-control"
                        id="validationCustom03"
                        maxLength={"500"}
                        value={remarks}
                        disabled={isView || StatusID == 2}
                        // onInput={toInputUppercase}
                        onChange={(e) =>
                          this.setState({ remarks: e.target.value })
                        }
                      />
                    </div>
                  </div>
                  {/* <div className="row mt-3">
                      <h6 className="mt-2">
                        Select Days
                        <span className="text-red">*</span>
                      </h6>
                      {allDaysList.length > 0 &&
                        allDaysList.map((data) => (
                          <div className="col-xl-2 px-3 " key={data.Code}>
                            <div className="form-group mb-2">
                              <label className="custom-control custom-checkbox mb-0">
                                <input
                                  type="checkbox"
                                  className="custom-control-input"
                                  name="example-checkbox1"
                                  select={data.isSelect}
                                  checked={data.isSelect}
                                  disabled={isView || StatusID == 2}
                                  value={data.Code}
                                  onChange={(e) => this.onSelectAllDates(e)}
                                />
                                <span className="custom-control-label">
                                  {data.description}
                                </span>
                              </label>
                            </div>
                          </div>
                        ))}
                      {daysList.length > 0 &&
                        daysList.map((data, i) => (
                          <div className="col-xl-2 px-3 ">
                            <div className="form-group mb-2">
                              <label className="custom-control custom-checkbox mb-0">
                                <input
                                  type="checkbox"
                                  className="custom-control-input"
                                  name="example-checkbox1"
                                  checked={data.isSelect}
                                  disabled={data.isReadOnly || isView}
                                  onChange={(e) => this.onSelectDates(e, i)}
                                />
                                <span className="custom-control-label">
                                  {data.description}
                                </span>
                              </label>
                            </div>
                          </div>
                        ))}
                    </div> */}

                  <div className="d-flex justify-content-start gap-2 mt-3 flex-wrap mb-3">

                    {/* Add / Clear */}
                    {isAdd && (
                      <>
                        <button
                          type="button"
                          className="btn btn-aqua"
                          disabled={UnPaid ? exhbitorBadgeList.length == MaxUnpaidBadge : false}
                          onClick={() => this.AddBadges()}
                        >
                          Add
                        </button>

                        {/* <button
                            type="button"
                            className="btn btn-gray"
                            onClick={() => this.OnCancel()}
                          >
                            Clear
                          </button> */}
                      </>
                    )}
                  </div>

                  {/* && !isUpdate */}
                  {exhbitorBadgeList.length && !isUpdate && !isView ? exhbitorBadgeList.map((item, i) => (
                    <div className="col-md-12">
                      <div className="shadow-none rounded-3 mb-1 border p-0">
                        <div
                          className="card-header py-2 d-flex align-items-center justify-content-between"
                        >
                          <span>{`${item.Name} / ${item.Designation} / ${item.Email} / ${item.MobileNo}`}</span>

                          <div className="d-flex align-items-center">
                            {/* EDIT / SAVE */}
                            <button
                              className="btn btn-aqua rounded-0"
                              onClick={() => {
                                const hasError = this.inputValidateListData(i);

                                this.setState(prevState => ({
                                  exhbitorBadgeList: prevState.exhbitorBadgeList.map((obj, index) => {
                                    if (index !== i) return obj;

                                    // 👉 ENTER EDIT MODE
                                    if (!obj.isEdit) {
                                      return {
                                        ...obj,
                                        isEdit: true,
                                        _backup: { ...obj } // store previous data
                                      };
                                    }

                                    // 👉 SAVE MODE
                                    if (hasError) {
                                      toastError("Please add mandatory fields!");
                                      return { ...obj, isEdit: true };
                                    }

                                    toastSuccess("Record updated successfully!");

                                    const { _backup, ...savedObj } = obj;
                                    return {
                                      ...savedObj,
                                      isEdit: false
                                    };
                                  })
                                }));
                              }}
                            >
                              {!item.isEdit ? "Edit" : "Save"}
                            </button>

                            {/* CANCEL */}
                            {item.isEdit &&
                              <button
                                className="btn apper-cancel rounded-0 mx-1"
                                onClick={() => {
                                  this.setState(prevState => ({
                                    exhbitorBadgeList: prevState.exhbitorBadgeList.map((obj, index) => {
                                      if (index !== i) return obj;

                                      // restore previous values
                                      return {
                                        ...obj._backup,
                                        isEdit: false,
                                        _backup: null
                                      };
                                    })
                                  }));
                                }}
                              >
                                Cancel
                              </button>
                            }
                            {/* DELETE */}
                            <button
                              className="btn btn-outline-danger rounded-0 mx-1"
                              onClick={() => {
                                this.setState(prevState => ({
                                  exhbitorBadgeList: prevState.exhbitorBadgeList.filter((obj, index) => index != i)
                                }));
                              }}
                            >
                              Delete
                            </button>
                          </div>

                        </div>
                        {item.isEdit &&
                          <div className="card-body row pt-3">
                            <div className="row">

                              {/* Exhibitor Name */}
                              <div className="col-xl-8">
                                <label>
                                  Exhibitor Name<span className="text-red">*</span>
                                </label>
                                <input
                                  type="text"
                                  className="form-control"
                                  disabled={!item.isEdit || StatusID == 2}
                                  value={item.Name}
                                  onChange={(e) =>
                                    this.handleFieldChange(i, "Name", e.target.value)
                                  }
                                />
                                <span className="text-danger d-block mt-1 text-start">
                                  {item.NameErr}
                                </span>
                              </div>

                              {/* Designation */}
                              <div className="col-xl-4">
                                <label>
                                  Designation<span className="text-red">*</span>
                                </label>
                                <input
                                  type="text"
                                  className="form-control"
                                  disabled={!item.isEdit || StatusID == 2}
                                  value={item.Designation}
                                  onChange={(e) =>
                                    this.handleFieldChange(i, "Designation", e.target.value)
                                  }
                                />
                                <span className="text-danger d-block mt-1 text-start">
                                  {item.DesignationErr}
                                </span>
                              </div>

                              {/* Country */}
                              <div className="col-xl-4 mt-3">
                                <label>
                                  Country<span className="text-red">*</span>
                                </label>
                                <select
                                  className="form-control"
                                  disabled={!item.isEdit || StatusID == 2}
                                  value={item.countryid}
                                  onChange={(e) =>
                                    this.handleFieldChange(i, "countryid", e.target.value)
                                  }
                                >
                                  <option value="">Select</option>
                                  {countryList.map(c => (
                                    <option key={c.Code} value={c.Code}>
                                      {c.Description}
                                    </option>
                                  ))}
                                </select>
                                <span className="text-danger d-block mt-1 text-start">
                                  {item.countryErr}
                                </span>
                              </div>

                              {/* City */}
                              <div className="col-xl-4 mt-3">
                                <label>
                                  City<span className="text-red">*</span>
                                </label>
                                <input
                                  type="text"
                                  className="form-control"
                                  disabled={!item.isEdit || StatusID == 2}
                                  value={item.City}
                                  onChange={(e) =>
                                    this.handleFieldChange(i, "City", e.target.value)
                                  }
                                />
                                <span className="text-danger d-block mt-1 text-start">
                                  {item.CityErr}
                                </span>
                              </div>

                              {/* State */}
                              <div className="col-xl-4 mt-3">
                                <label>
                                  {item.countryid == 91 ? "State*" : "State/Province"}
                                </label>
                                <input
                                  type="text"
                                  className="form-control"
                                  disabled={!item.isEdit || StatusID == 2}
                                  value={item.State}
                                  onChange={(e) =>
                                    this.handleFieldChange(i, "State", e.target.value)
                                  }
                                />
                                <span className="text-danger d-block mt-1 text-start">
                                  {item.StateErr}
                                </span>
                              </div>

                              {/* Company Name */}
                              <div className="col-xl-4 mt-3">
                                <label>
                                  Company Name<span className="text-red">*</span>
                                </label>
                                <input
                                  type="text"
                                  className="form-control"
                                  // disabled={!item.isEdit || StatusID == 2}
                                  disabled={true}
                                  value={item.CompanyName}
                                  onChange={(e) =>
                                    this.handleFieldChange(i, "CompanyName", e.target.value)
                                  }
                                />
                                <span className="text-danger d-block mt-1 text-start">
                                  {item.CompanyNameErr}
                                </span>
                              </div>

                              {/* Email */}
                              <div className="col-xl-4 mt-3">
                                <label>
                                  Email<span className="text-red">*</span>
                                </label>
                                <input
                                  type="text"
                                  className="form-control"
                                  disabled={!item.isEdit || StatusID == 2}
                                  value={item.Email}
                                  onChange={(e) => this.handleEmailChange(i, e)}
                                />
                                <span className="text-danger d-block mt-1 text-start">
                                  {item.EmailErr}
                                </span>
                              </div>

                              {/* Mobile */}
                              <div className="col-xl-4 mt-3">
                                <label>
                                  Mobile No<span className="text-red">*</span>
                                </label>
                                <input
                                  type="text"
                                  className="form-control"
                                  disabled={!item.isEdit || StatusID == 2}
                                  maxLength={item.countryid == 91 ? 10 : 12}
                                  value={item.MobileNo}
                                  onChange={(e) => this.handleMobileChange(i, e)}
                                />
                                <span className="text-danger d-block mt-1 text-start">
                                  {item.MobileNoErr}
                                </span>
                              </div>

                              {/* Category */}
                              <div className="col-xl-8 mt-3">
                                <label>
                                  Category<span className="text-red">*</span>
                                </label>
                                <Select
                                  isMulti
                                  isDisabled={!item.isEdit || StatusID == 2}
                                  value={item.ExhBadgesProductCategoryList}
                                  options={ProductCategoryList}
                                  onChange={(value) =>
                                    this.handleFieldChange(
                                      i,
                                      "ExhBadgesProductCategoryList",
                                      value
                                    )
                                  }
                                />
                                <span className="text-danger d-block mt-1 text-start">
                                  {item.ExhBadgesProductCategoryListErr}
                                </span>
                              </div>

                              {/* Remarks */}
                              <div className="col-xl-12 mt-3">
                                <label>Remarks</label>
                                <textarea
                                  className="form-control"
                                  disabled={!item.isEdit || StatusID == 2}
                                  value={item.Remark}
                                  onChange={(e) =>
                                    this.handleFieldChange(i, "Remark", e.target.value)
                                  }
                                />
                              </div>

                            </div>

                            {/* <div className="row mt-3 p-0">
                                <h6 className="mt-2">
                                  Select Days
                                  <span className="text-red">*</span>
                                </h6>

                                {item.allDaysList.length > 0 &&
                                  item.allDaysList.map((data) => (
                                    <div className="col-xl-2 px-3" key={data.Code}>
                                      <div className="form-group mb-2">
                                        <label className="custom-control custom-checkbox mb-0">
                                          <input
                                            type="checkbox"
                                            className="custom-control-input"
                                            name="example-checkbox1"
                                            checked={data.isSelect}
                                            disabled={isView || !item.isEdit || StatusID == 2}
                                            value={data.Code}
                                            onChange={(e) =>
                                              this.handleAllDaysChange(i, e.target.checked)
                                            }
                                          />
                                          <span className="custom-control-label">
                                            {data.description}
                                          </span>
                                        </label>
                                      </div>
                                    </div>
                                  ))}
                                {item.daysList.length > 0 &&
                                  item.daysList.map((data, dayIndex) => (
                                    <div className="col-xl-2 px-3" key={dayIndex}>
                                      <div className="form-group mb-2">
                                        <label className="custom-control custom-checkbox mb-0">
                                          <input
                                            type="checkbox"
                                            className="custom-control-input"
                                            name="example-checkbox1"
                                            checked={data.isSelect}
                                            disabled={data.isReadOnly || isView || !item.isEdit || StatusID == 2}
                                            onChange={(e) =>
                                              this.handleDayChange(
                                                i,
                                                dayIndex,
                                                e.target.checked
                                              )
                                            }
                                          />
                                          <span className="custom-control-label">
                                            {data.description}
                                          </span>
                                        </label>
                                      </div>
                                    </div>
                                  ))}
                              </div> */}

                          </div>
                        }

                      </div>
                    </div>
                  )) : <></>}


                  {!UnPaid && exhbitorBadgeList.length > 0 && (
                    <div className="row mt-3">
                      <div class="table-responsive">
                        <table class="table border text-nowrap text-md-nowrap table-bordered mb-0 mt-1">
                          <thead>
                            <tr>
                              <th>Exhibitor Name</th>
                              <th>Description of Service</th>
                              <th>Rates ({CurrencyName})</th>
                              <th>Quantity</th>
                              <th>Amount({CurrencyName})</th>
                            </tr>
                          </thead>
                          <tbody>
                            {console.log("exhbitorBadgeList------>", exhbitorBadgeList)}
                            {exhbitorBadgeList.length > 0 ? exhbitorBadgeList.map(item => (
                              <>
                                {item.PriceList.length > 0 ? (
                                  item.PriceList.map((data, i) => (
                                    <>
                                      {data.IsShow && (
                                        <tr>
                                          <td>{data.exhibitorName}</td>
                                          <td>
                                            {data.Quantity != 0
                                              ? `${data.Description != "All Day" ? data.Quantity : ''} ${data.Description}`
                                              : data.Description}
                                          </td>
                                          <td>{data.Rates}</td>
                                          <td>{data.Quantity || "-"}</td>
                                          <td>{data.Amount}</td>
                                        </tr>
                                      )}
                                    </>
                                  ))
                                ) : (
                                  <></>
                                )}
                              </>
                            ))
                              :
                              <></>
                            }
                            <tr>
                              <td colspan="2"></td>
                              <td>
                                <strong>Total</strong>
                              </td>
                              <td>
                                <strong>{exhbitorBadgeList.reduce((total, item) => {
                                  const qty = item.PriceList?.reduce(
                                    (sum, p) => sum + (Number(p.Quantity) || 0),
                                    0
                                  ) || 0
                                  return total + qty;
                                }, 0)}</strong>
                              </td>
                              <td>
                                <strong>{totalAmount}</strong>
                              </td>
                            </tr>
                            {!IsIGST ? (
                              <>
                                <tr>
                                  <td colspan="2"></td>
                                  <td>
                                    <strong>CGST @ {CGST}%</strong>
                                  </td>
                                  <td>
                                    <strong>-</strong>
                                  </td>
                                  <td>
                                    <strong>
                                      {(CGST && totalAmount)
                                        ? ((CGST / 100) * totalAmount).toFixed(2)
                                        : "0.00"}
                                    </strong>
                                  </td>
                                </tr>
                                <tr>
                                  <td colspan="2"></td>
                                  <td>
                                    <strong>SGST @ {SGST}%</strong>
                                  </td>
                                  <td>
                                    <strong>-</strong>
                                  </td>
                                  <td>
                                    <strong>
                                      {(SGST && totalAmount)
                                        ? ((SGST / 100) * totalAmount).toFixed(2)
                                        : "0.00"}
                                    </strong>
                                  </td>
                                </tr>
                              </>
                            ) : (
                              <tr>
                                <td colspan="2"></td>
                                <td>
                                  <strong>IGST @ {IGST}%</strong>
                                </td>
                                <td>
                                  <strong>-</strong>
                                </td>
                                <td>
                                  <strong>
                                    {(IGST && totalAmount)
                                      ? ((IGST / 100) * totalAmount).toFixed(2)
                                      : "0.00"}
                                  </strong>
                                </td>
                              </tr>
                            )}
                            <tr style={{ backgroundcolor: "#eee" }}>
                              <td colspan="2"></td>
                              <td>
                                <strong>Grand Total</strong>
                              </td>
                              <td>
                                <strong>-</strong>
                              </td>
                              <td>
                                <strong>
                                  {
                                    (() => {
                                      const total = Number(totalAmount) || 0;
                                      const cgstAmount = (total * (Number(CGST) || 0)) / 100;
                                      const sgstAmount = (total * (Number(SGST) || 0)) / 100;

                                      const grandTotal = total + cgstAmount + sgstAmount;

                                      return Math.round(grandTotal).toFixed(2);
                                    })()
                                  }
                                </strong>
                              </td>
                            </tr>
                          </tbody>
                        </table>
                      </div>
                    </div>
                  )}
                </div>

                <div className="d-flex justify-content-end gap-2 mt-3 flex-wrap mb-3">

                  {/* Submit */}
                  {isAdd && (
                    <button
                      className="btn btn-aqua"
                      disabled={exhbitorBadgeList.length == 0}
                      // onClick={() => this.onSubmitExhibitorBadge()}
                      onClick={() => this.setState({ isOpenConfirmationModal: true, confirmationObj: { message: 'Do you want to Submit?', buttonName: 'Submit', action: 0 }, popArg: [] })}
                    >
                      Submit
                    </button>
                  )}

                  {/* Update */}
                  {isUpdate && (
                    <button
                      className="btn btn-aqua"
                      // onClick={() => this.onUpdateExhibitorBadge()}
                      onClick={() => this.setState({ isOpenConfirmationModal: true, confirmationObj: { message: 'Do you want to Update?', buttonName: 'Update', action: 1 }, popArg: [] })}
                    >
                      Update
                    </button>
                  )}

                  {/* Back */}
                  {!isHideSection && (
                    <button
                      className="btn btn-gray"
                      onClick={() => this.OnCancel()}
                    >
                      Back
                    </button>
                  )}

                </div>

              </div>
            </div>
          </div>
        </div>
        <Modal
          isOpen={isDelOpen}
          onRequestClose={() => this.setState({ isDelOpen: false })}
        >
          <div className="modal-dialog">
            <div className="modal-content confirm-logout">
              <div class="modal-header p-2">
                <h5 class="modal-title">
                  Confirm Delete
                </h5>
                <button
                  type="button "
                  class="close pop-close"
                  data-dismiss="modal"
                  onClick={() => this.setState({ isDelOpen: false })}
                >
                  <span aria-hidden="true" class="pop-cancel">
                    &times;
                  </span>
                </button>
              </div>
              <div class="modal-body">
                <div class="row">
                  <div class="col-md-12">
                    <p class="pop_label">
                      Do you really want to delete this Document?
                    </p>
                  </div>
                </div>
              </div>
              <div class="modal-footer p-1">
                <div class="form-group text-right mod-fot">
                  <button
                    type="button"
                    class="btn btn-aqua"
                    onClick={(e) => this.handleDelete(e)}
                  >
                    Yes
                  </button>
                  <button
                    type="button"
                    class="btn btn-gray"
                    data-dismiss="modal"
                    style={{ marginLeft: "5px" }}
                    onClick={() => this.setState({ isDelOpen: false })}
                  >
                    No
                  </button>
                </div>
              </div>
            </div>
          </div>
        </Modal>
      </>
    );
  }
}
export default withRouter(
  connect(null, {
    addExhibitorBadge_action,
    fill_action,
    getExhibitorBadgeDetails_action,
    updateExhibitorBadge_action,
    deleteExBadgeDoc_action,
    defaultExhBadgeDetails_action,
    getExhBadgeStatusCount_action
  })(AddExhibitorBadge)
);
